import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-email_2fe2b2e9ccdc2190339b63c4c548e2cc",
  "use": "ic-email_2fe2b2e9ccdc2190339b63c4c548e2cc-usage",
  "viewBox": "0 0 13 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 13 9\" id=\"ic-email_2fe2b2e9ccdc2190339b63c4c548e2cc\">\n    <path fill=\"#222\" d=\"M.457 1a1 1 0 0 1 1-1h9.477a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1.457a1 1 0 0 1-1-1V1z\" />\n    <path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".8\" d=\"M.404.465l6.04 3.577 5.49-3.527\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id